import { type IconButtonProps } from "@clipboard-health/ui-components";
import { AbsoluteSmallButton } from "@src/appV2/redesign/components/AbsoluteSmallButton";

export function TopLeftBackButton(props: { onClick: () => void } & Partial<IconButtonProps>) {
  return <AbsoluteSmallButton iconType="arrow-left" position="left" label="Back" {...props} />;
}
